import React from "react";

/* A panel with glowing HUD corner brackets. */
export default function HudFrame({ children, style, accent = "var(--cyan)", className }) {
  const bracket = (pos) => {
    const base = {
      position: "absolute",
      width: "14px",
      height: "14px",
      borderColor: accent,
      borderStyle: "solid",
      borderWidth: 0,
      pointerEvents: "none",
    };
    const map = {
      tl: { top: -1, left: -1, borderTopWidth: 2, borderLeftWidth: 2 },
      tr: { top: -1, right: -1, borderTopWidth: 2, borderRightWidth: 2 },
      bl: { bottom: -1, left: -1, borderBottomWidth: 2, borderLeftWidth: 2 },
      br: { bottom: -1, right: -1, borderBottomWidth: 2, borderRightWidth: 2 },
    };
    return <span style={{ ...base, ...map[pos] }} />;
  };

  return (
    <div
      className={className}
      style={{
        position: "relative",
        background: "var(--panel)",
        border: "1px solid var(--line)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        ...style,
      }}
    >
      {bracket("tl")}
      {bracket("tr")}
      {bracket("bl")}
      {bracket("br")}
      {children}
    </div>
  );
}
